module.exports = __webpack_public_path__ + "img/deleteAcc.2c862caa.svg";